import React, { useContext } from 'react'
import styles  from './ChatBubble.module.scss'
import classNames from 'classnames/bind';
import AppDataContext from '../../../../context/AppDataContext';
import Avatar from '../../../../components/Avatar/Avatar';
let cx = classNames.bind(styles);


export default function ChatBubble({chat}: any) {
  const {  user } : any = useContext(AppDataContext);
  const isMyChat = chat.userName === user.userName;
  let chatRow = cx({
    chatRow: true,
    right: isMyChat
  });

  return (
    <div className={chatRow}>


    {/* User Avatar */}
    {!isMyChat && (      
      <Avatar src={chat.picture} alt={chat.fullName} status={chat.status} />
    )}


      <div className={styles.chatText}>
        <div className={styles.userInfo}>
          <h4>{isMyChat? 'You': chat.fullName }</h4>
          <span>{chat.time}</span>
        </div>

        <div className={styles.chatBubble}>
            {chat.messages}
        </div>        
      </div>

    </div>
  )
}
